import { formatter } from 'utils'

import { useMemberProfileVersion } from './useMemberProfileVersion'

import { isWFClient } from 'setups/controller'
import { projectClient } from 'constants/project'

const Index = (): JSX.Element => {
  const { memberMemberProfiles } = useMemberProfileVersion()

  return (
    <>
      {memberMemberProfiles.map((item) => (
        <div key={item.traderId} className="flex flex-col gap-2">
          <p className="text-xs uppercase font-light tracking-wider">
            Mailing Preference
          </p>
          <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
            {item.mailingPreferenceName || '---'}
          </p>
          <p className="text-xs uppercase font-light tracking-wider">
            Last Modified
          </p>
          <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
            {formatter.displayDate(item.lastModifiedDate)}
          </p>

          <p className="text-xs uppercase font-light tracking-wider">Ranking</p>
          <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
            {item.ranking || '---'}
          </p>
          <p className="text-xs uppercase font-light tracking-wider">RAF</p>
          <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
            {item.promoCode || '---'}
          </p>
          <p className="text-xs uppercase font-light tracking-wider">PROMO</p>
          <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
            {item.website || '---'}
          </p>
          <p className="flex flex-col gap-2">
            <span className="text-xs uppercase font-light tracking-wider">
              Comments
            </span>
              <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
                {item.comments || '---'}
              </p>
          </p>
          {isWFClient(projectClient) && (
            <>
              <p className="text-xs uppercase font-light tracking-wider">
                External ID
              </p>
              <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
                {item.externalId || '---'}
              </p>
              <p className="text-xs uppercase font-light tracking-wider">
                Custom_2
              </p>
              <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
                {item.custom2 || '---'}
              </p>
            </>
          )}
        </div>
      ))}
    </>
  )
}

export default Index
